import React, { useEffect } from "react";
import { useTranslation } from "@/langs/useTranslation";
import { getNubisDriveFileList } from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import { transformedFormatBytes } from "@/helpers/formatBytesTransformer";
import { utcStringToLocalDatetimeConverter } from "@/helpers/datetimeHandlers";

export const FileListDataTable = React.forwardRef(
  (
    {
      className,
      style,
      footer,
      children,
      onCheckAll,
      onLoaded,
      single,
      target = "file",
      fileType,
      checkedList,
      filter
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [loaded, setLoaded] = React.useState(false);

    const columns = [
      {
        data: "id",
        type: "checkbox"
      },
      {
        data: "name",
        title: t({ defaultMessage: "文件名" }),
        searchable: false,
        orderable: false
      },
      {
        data: "extension",
        title: t({ defaultMessage: "格式" }),
        searchable: false,
        orderable: false
      },
      {
        data: "size",
        title: `${t({ defaultMessage: "大小" })}`,
        render: data => transformedFormatBytes(data),
        searchable: false,
        orderable: false
      },
      {
        data: "creator_name",
        title: t({ defaultMessage: "上传者" }),
        searchable: false,
        orderable: false,
        render: data => data || "-"
      },
      {
        data: "uploaded_at",
        title: t({ defaultMessage: "上传时间" }),
        searchable: false,
        orderable: false,
        render: data => utcStringToLocalDatetimeConverter(data)
      }
    ];

    const ajax = (data, callback) => {
      // let orderType;
      // let orderWay;
      // const order = data.order[0];
      // if (order && data.columns[order.column]?.orderable) {
      //   orderType = data.columns[order.column]?.name;
      //   // orderType = order.column;
      //   orderWay = order.dir === "asc" ? 1 : 2;
      // }
      return getNubisDriveFileList({
        // orderWay,
        // orderType,
        // ...getSearchParams(),
        parent_id: "",
        target,
        file_type: fileType,
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        console.log(res.data)
        callback({
          data: res.data.filter(filter),
          draw: data.draw,
          recordsFiltered: res.recordsFiltered,
          recordsTotal: res.recordsTotal
        });
      });
    };

    const handleLoaded = () => {
      onLoaded?.();
      setLoaded(true);
    };

    useEffect(() => {
      if (loaded && checkedList && checkedList.length > 0) {
        const api = ref.current.api();
        const data = api.data().toArray();
        api
          .cells(
            api
              .rows()
              .indexes()
              .filter(idx => checkedList.includes(data[idx].id)),
            0
          )
          .checkboxes.select(true);
      }
    }, [checkedList, loaded]);

    return (
      <>
        <DataTable
          ref={ref}
          ordering
          columns={columns}
          ajax={ajax}
          className={className}
          style={style}
          footer={footer}
          scrollable
          showCheckAll={false}
          onCheckAll={onCheckAll}
          onLoaded={handleLoaded}
          autoLoad
          singleCheck={single}
        >
          {children}
        </DataTable>
      </>
    );
  }
);
